import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    width={17 * (props.wx ?? 1)}
    height={29 * (props.hx ?? 1)}
    viewBox="0 0 17 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <mask
      id="path-1-outside-1_2050_98"
      maskUnits="userSpaceOnUse"
      x="0.766113"
      y="0.324585"
      width="16"
      height="28"
      fill="black"
    >
      <rect fill="white" x="0.766113" y="0.324585" width="16" height="28" />
      <path d="M8.76634 1.97609C7.56747 1.97609 4.44974 0.256131 2.64894 2.40534C1.20587 4.12776 1.73887 8.26977 2.7733 11.0569C3.15806 12.094 3.18233 13.0808 3.16611 14.1998C3.09042 19.5176 1.6366 26.8221 2.7733 26.8246C3.91001 26.8271 6.62583 14.9735 8.76588 14.1998C9.63857 13.8845 11.7661 17.8246 12.2661 20.3246C12.7661 22.8246 13.0742 27.3246 13.7661 27.3246C14.458 27.3246 14.7589 22.8246 14.7589 21.8246C14.7589 20.8246 14.4091 16.5789 14.458 14.1998C14.481 13.0808 14.3742 12.0935 14.7589 11.0569C15.7934 8.26928 16.3264 4.12727 14.8833 2.40534C13.0825 0.256131 9.96522 1.97609 8.76634 1.97609Z" />
    </mask>
    <path
      d="M8.76634 1.97609C7.56747 1.97609 4.44974 0.256131 2.64894 2.40534C1.20587 4.12776 1.73887 8.26977 2.7733 11.0569C3.15806 12.094 3.18233 13.0808 3.16611 14.1998C3.09042 19.5176 1.6366 26.8221 2.7733 26.8246C3.91001 26.8271 6.62583 14.9735 8.76588 14.1998C9.63857 13.8845 11.7661 17.8246 12.2661 20.3246C12.7661 22.8246 13.0742 27.3246 13.7661 27.3246C14.458 27.3246 14.7589 22.8246 14.7589 21.8246C14.7589 20.8246 14.4091 16.5789 14.458 14.1998C14.481 13.0808 14.3742 12.0935 14.7589 11.0569C15.7934 8.26928 16.3264 4.12727 14.8833 2.40534C13.0825 0.256131 9.96522 1.97609 8.76634 1.97609Z"
      fill={props.fill || '#E4E4E7'}
    />
    <path
      d="M8.76634 1.97609C7.56747 1.97609 4.44974 0.256131 2.64894 2.40534C1.20587 4.12776 1.73887 8.26977 2.7733 11.0569C3.15806 12.094 3.18233 13.0808 3.16611 14.1998C3.09042 19.5176 1.6366 26.8221 2.7733 26.8246C3.91001 26.8271 6.62583 14.9735 8.76588 14.1998C9.63857 13.8845 11.7661 17.8246 12.2661 20.3246C12.7661 22.8246 13.0742 27.3246 13.7661 27.3246C14.458 27.3246 14.7589 22.8246 14.7589 21.8246C14.7589 20.8246 14.4091 16.5789 14.458 14.1998C14.481 13.0808 14.3742 12.0935 14.7589 11.0569C15.7934 8.26928 16.3264 4.12727 14.8833 2.40534C13.0825 0.256131 9.96522 1.97609 8.76634 1.97609Z"
      stroke={props.stroke || '#A1A1AA'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      mask="url(#path-1-outside-1_2050_98)"
    />
  </svg>
);
export default SvgNormal;
